import { ConditionalLinkProps } from "./ConditionalLink.types";
import { Link } from "react-router-dom";

const ConditionalLink = ({ condition, children, style, className, onClick, ...linkProps }: ConditionalLinkProps): JSX.Element =>
    condition ? (
        <Link style={{ display: "flex", ...style }} className={className} onClick={onClick} {...linkProps}>
            {children}
        </Link>
    ) : (
        // skipcq: JS-0765
        <button
            style={{
                ...style,
                display: "flex",
                justifyContent: "center",
                border: "none",
                background: "none",
                margin: "0px",
                padding: "0px",
            }}
            className={className}
            onClick={onClick}
        >
            <span>{children}</span> {/* skipcq: JS-0746 */}
        </button>
    );

export default ConditionalLink;
